module.exports = __webpack_public_path__ + "img/techExpertise.c89916c4.png";